import { createRouter, createWebHistory, RouteMeta, RouteRecordRaw } from 'vue-router';

import AuthLayout from '../layouts/AuthLayout.vue';
import AppLayout from '../layouts/AppLayout.vue';

import RouteViewComponent from '../layouts/RouterBypass.vue';
import Cookies from 'js-cookie';
import { COOKIE_ACCESS_TOKEN } from '@/utils/constant';
import { PARTNER_HIDE } from '@/utils/env';

const routes: RouteRecordRaw[] = [
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: 'dashboard' },
  },
  {
    name: 'admin',
    path: '/',
    component: AppLayout,
    redirect: { name: 'dashboard' },
    children: [
      {
        name: 'dashboard',
        path: 'dashboard',
        component: () => import('../pages/admin/dashboard/Dashboard.vue'),
        meta: { displayName: '대시보드' } as RouteMeta,
      },
      {
        name: 'menuRelated',
        path: 'menu',
        meta: { displayName: '메뉴', icon: 'restaurant' },
        children: [
          {
            name: 'menu',
            path: 'menu',
            meta: { displayName: '메뉴', icon: 'menu_book' },
            component: () => import('../pages/menu/MenusPage.vue'),
          },
          {
            name: 'submenu',
            path: 'submenu',
            meta: { displayName: '서브메뉴', icon: 'menu_book' },
            component: () => import('../pages/submenu/SubmenusPage.vue'),
          },
          {
            name: 'category',
            path: 'category',
            meta: { displayName: '카테고리', icon: 'menu_book' },
            component: () => import('../pages/category/CategoriesPage.vue'),
          },
          {
            name: 'product',
            path: 'product',
            meta: { displayName: '상품', icon: 'shopping_cart' },
            component: () => import('../pages/product/ProductsPage.vue'),
          },
        ],
      },
      {
        name: 'event',
        path: 'event',
        component: () => import('../pages/event/EventsPage.vue'),
        meta: { displayName: '행사사례', icon: 'cake' } as RouteMeta,
      },
      {
        name: 'template',
        path: 'template',
        meta: { displayName: '케닷박스', icon: 'copy_all' },
        component: () => import('../pages/template/TemplatesPage.vue'),
      },
      {
        name: 'shippingRelated',
        path: 'shipping',
        meta: { displayName: '배송', icon: 'local_shipping' },
        children: [
          {
            name: 'deliveryMethod',
            path: 'method',
            meta: { displayName: '배송 방법', icon: 'local_shipping' },
            component: () => import('../pages/shipping/DeliveryMethodPage.vue'),
          },
        ],
      },
      {
        name: 'orderRelated',
        path: 'order',
        meta: { displayName: '주문', icon: 'call' },
        children: [
          {
            name: 'depositAccount',
            path: 'method',
            meta: { displayName: '무통장입금 계좌', icon: 'account_balance_wallet' },
            component: () => import('../pages/order/DepositAccountPage.vue'),
          },
          {
            name: 'order',
            path: 'order',
            meta: { displayName: '주문 관리', icon: 'pending_actions' },
            component: () => import('../pages/order/OrdersPage.vue'),
          },
          {
            name: 'estimate',
            path: 'estimate',
            meta: { displayName: '견적서', icon: 'pending_actions' },
            component: () => import('../pages/estimate/EstimatesPage.vue'),
          },
        ],
      },
      {
        name: 'tax-invoice',
        path: 'tax-invoice',
        meta: { displayName: '세금계산서', icon: 'request_quote' },
        component: () => import('../pages/tax-invoice/TaxInvoicesPage.vue'),
      },
      {
        name: 'notice',
        path: 'notice',
        meta: { displayName: '공지사항', icon: 'edit_notifications' },
        component: () => import('../pages/notice/NoticesPage.vue'),
      },
      {
        name: 'popup',
        path: 'popup',
        meta: { displayName: '공지사항 팝업', icon: 'announcement' },
        component: () => import('../pages/popup/PopupsPage.vue'),
      },
      {
        name: 'user',
        path: 'user',
        meta: { displayName: '회원', icon: 'groups' },
        component: () => import('../pages/user/UsersPage.vue'),
      },
      ...(PARTNER_HIDE
        ? []
        : [
            {
              name: 'partnerRelated',
              path: 'partner',
              meta: { displayName: '파트너관리', icon: 'handshake' },
              children: [
                {
                  name: 'partnerEstimate',
                  path: 'estimate',
                  meta: { displayName: '견적관리', icon: 'request_quote' },
                  component: () => import('../pages/partner/PartnerEstimatePage.vue'),
                },
                {
                  name: 'partnerPayouts',
                  path: 'payouts',
                  meta: { displayName: '적립금 전환', icon: 'savings' },
                  component: () => import('../pages/partner/PartnerPayoutsPage.vue'),
                },
                {
                  name: 'partner',
                  path: 'partner',
                  meta: { displayName: '파트너관리', icon: 'handshake' },
                  component: () => import('../pages/partner/PartnersPage.vue'),
                },
                {
                  name: 'partnerSettlement',
                  path: 'settlement',
                  meta: { displayName: '정산관리', icon: 'payments' },
                  component: () => import('../pages/partner/PartnerSettlementPage.vue'),
                },
                {
                  name: 'partnerStats',
                  path: 'stats',
                  meta: { displayName: '통계', icon: 'bar_chart' },
                  component: () => import('../pages/partner/PartnerStatsPage.vue'),
                },
              ],
            },
          ]),

      { name: 'demo', path: 'demo', component: () => import('../pages/demo/DemoPage.vue') },
      // 이하 데모 페이지
      {
        name: 'settings',
        path: 'settings',
        component: () => import('../pages/settings/Settings.vue'),
      },
      {
        name: 'faq',
        path: '/faq',
        component: () => import('../pages/faq/FaqPage.vue'),
      },
    ],
  },
  {
    path: '/auth',
    component: AuthLayout,
    children: [
      {
        name: 'login',
        path: 'login',
        component: () => import('../pages/auth/Login.vue'),
        meta: { guestOnly: true },
      },
      {
        name: 'signup',
        path: 'signup',
        component: () => import('../pages/auth/Signup.vue'),
        meta: { guestOnly: true },
      },
      {
        name: 'recover-password',
        path: 'recover-password',
        component: () => import('../pages/auth/RecoverPassword.vue'),
        meta: { guestOnly: true },
      },
      {
        name: 'recover-password-email',
        path: 'recover-password-email',
        component: () => import('../pages/auth/CheckTheEmail.vue'),
        meta: { guestOnly: true },
      },
      {
        path: '',
        redirect: { name: 'login' },
      },
    ],
  },
  {
    name: '404',
    path: '/404',
    component: () => import('../pages/404.vue'),
  },
];

function traverseRoutes(routes: RouteRecordRaw[], depth = 0, parentName: string = '') {
  return routes.map((route) => {
    // Add depth and parent to the route
    const enrichedRoute = {
      ...route,
      meta: { ...(route.meta ?? {}), depth, parent: parentName },
    };

    // Recursively process children if they exist
    if (route.children && route.children.length > 0) {
      enrichedRoute.children = traverseRoutes(route.children, depth + 1, route.name?.toString());
    }

    return enrichedRoute;
  });
}
const updatedRoutes = traverseRoutes(routes);

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    // For some reason using documentation example doesn't scroll on page navigation.
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' };
    } else {
      window.scrollTo(0, 0);
    }
  },
  routes: updatedRoutes,
});

type UserRole = 'guest' | 'admin';
router.beforeEach(async (to, from, next) => {
  let userRole: UserRole = 'guest';
  const token = Cookies.get(COOKIE_ACCESS_TOKEN) ?? '';
  if (token !== '') {
    userRole = 'admin';
  }
  if (to.meta.guestOnly && userRole !== 'guest') {
    return next('/');
  }
  if (!to.meta.guestOnly && userRole !== 'admin') {
    return next({ name: 'login' });
  }
  next();
});

export default router;
